import React, { Component, Fragment } from 'react';
import Description from '../Description';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import Asset from './Asset';
import { Link, Redirect } from 'react-router-dom';
import i18n from 'i18n/i18n';
import _ from 'lodash';
import { TeamAssetsLogoIcon, TeamAssetsImageIcon, TeamAssetsOtherIcon } from 'theme/icons';

const localize = i18n.loc.localize;

const styles = theme => ({
	root: {},
	assetRoot: {
		marginRight: 30
	},
	assetButton: {
		width: 70,
		height: 70,
		minWidth: 70,
		boxShadow: '1px 1px 3px rgba(0,0,0, 0.16)',
		borderRadius: 20,
		marginBottom: theme.spacing.unit,
		color: theme.palette.colors.zeta,
		'&:hover': {
			color: theme.palette.colors.zeta
		}
	},
	stepDescription: {
		marginBottom: 0
	},
	assetsContainer: {
		margin: `${theme.spacing.unit * 2}px 0 ${theme.spacing.unit * 3}px`
	},
	descriptionContainer: {
		maxWidth: 670
	},
	assetLabel: {
		textAlign: 'center',
		fontSize: 13,
		color: theme.palette.colors.zeta
	},
	selectedAsset: {
		backgroundColor: '#e5f6ff'
	}
});

const ASSETS = [{
	id: 'logo',
	title: 'Logos',
	icon: <TeamAssetsLogoIcon width='44px' height='44px' />,
	description: localize('assets-description-logo')
}, {
	id: 'image',
	title: 'Images',
	icon: <TeamAssetsImageIcon width='46px' height='30px' />,
	description: localize('assets-description-image')
}, {
	id: 'component',
	title: 'Other',
	icon: <TeamAssetsOtherIcon width='36px' height='30px' />,
	description: localize('assets-description-component')
}];

@withStyles(styles)
class Assets extends Component {
	state = {};

	setAsset(asset) {
		this.setState({
			selectedAsset: asset
		});
	}

	componentWillReceiveProps(nextProps, nextContext) {
		const assetId = nextProps.match.params.asset;

		if (assetId || (this.state.selectedAsset && this.state.selectedAsset.id !== assetId)) {
			this.setAsset(_.find(ASSETS, asset => asset.id === assetId));
		}
	}

	renderDescription() {
		const { classes } = this.props;
		const { selectedAsset } = this.state;

		if (!selectedAsset) {
			const assetsText = localize('assets-description-not-selected');
			return (
				<div className={classes.descriptionContainer}><Description>
					<span dangerouslySetInnerHTML={{ __html: assetsText }} />
				</Description></div>);
		}

		return (<div className={classes.descriptionContainer}><Description>
			<span dangerouslySetInnerHTML={{ __html: selectedAsset.description }} />
		</Description></div>);
	}

	renderAsset() {
		const { selectedAsset } = this.state;
		const { match, classes } = this.props;

		if (!selectedAsset) {
			return;
		}

		return (
			<Fragment>
				{!this.hasSelectedItemCloudFolders && <Grid item xs={12}>
					<Typography variant='h3' gutterBottom>
						{localize('assets-step-2')}
					</Typography>
					<Description className={classes.stepDescription}>
						{localize('assets-step-2-description')}
					</Description>
				</Grid>}
				<Asset type={selectedAsset.id} match={match} />
			</Fragment>
		);
	}

	renderAssets() {
		const { classes, match } = this.props;
		const { selectedAsset } = this.state;

		return (
			<Grid container>
				{!this.hasSelectedItemCloudFolders && <Grid item xs={12}>
					<Typography variant='h3' gutterBottom>
						{localize('assets-step-1')}
					</Typography>
					<Description className={classes.stepDescription}>
						{localize('assets-step-1-description')}
					</Description>
				</Grid>}
				<Grid container className={classes.assetsContainer}>
					{ASSETS.map(asset => {
						const buttonClass = classNames(classes.assetButton, {
							[classes.selectedAsset]: selectedAsset === asset
						});

						return (<div key={asset.id} className={classes.assetRoot}>
							<Button
								data-tid={`button-assets-type-${asset.id}`}
								className={buttonClass}
								component={Link}
								to={`/${match.params.companyId}/team-folders/assets/${asset.id}`}
							>
								{asset.icon}
							</Button>
							<Typography className={classes.assetLabel}>{asset.title}</Typography>
						</div>);
					})}
				</Grid>
				{this.renderAsset()}
			</Grid>
		);
	}

	render() {
		const { classes, match } = this.props;

		if (!match.params.asset) {
			return (<Redirect to={`/${match.params.companyId}/team-folders/assets/logo`} />);
		}

		return (<div className={classes.root}>
			{this.renderDescription()}
			{this.renderAssets()}
		</div>);
	}

	get hasSelectedItemCloudFolders() {
		const { selectedAsset } = this.state;
		const { folders } = this.props;

		if (folders && selectedAsset) {
			return folders[selectedAsset.id] && folders[selectedAsset.id].length > 0;
		}

		return false;
	}


}

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

Assets.propTypes = {
	match: PropTypes.object.isRequired,
	folders: PropTypes.object,
	classes: PropTypes.object
};

export default connect(
	mapDispatchToProps
)(Assets);



// WEBPACK FOOTER //
// ./src/components/TeamFolders/Assets.js